import { React } from 'mcelroy-lib'
import { FormPage, useToast } from 'mcelroy-components'

/*
    Batch Translation page (export/import Excel spreadsheet)
*/
export function BatchTranslationPage() {
    const toast = useToast()

    const fields = [
        {
            label: "Language", value: "es", name: "language",
            options: [
                {
                  label: "Spanish",
                  value: "es"
                },
                {
                    label: "German",
                    value: "de"
                  }
              ]
        }
    ]

    const buttons = [
        {
            label: 'Export Outdated',
            primary: true,
            onClick: async function (formData) {
                let uri = 'https://api.mcelroy.com/rest/translation/outdated/' + formData.language
                let link = document.createElement("a")
                link.href = uri
                link.click()
                link.remove()
            }
        },
        {
            label: 'Export All',
            onClick: async function (formData) {
                let uri = 'https://api.mcelroy.com/rest/translation/all/' + formData.language                
                let link = document.createElement('a')
                link.href = uri
                link.click()
                link.remove()
            }
        },
        {
            label: 'Import',
            onClick: async function (formData) {
                const input = document.createElement("input")
                input.type = 'file'
                input.click()

                return new Promise((resolve, reject) => {
                    input.addEventListener("change", event => {
                        const file = input.files[0]
                        input.remove()
                        uploadFile(file, 'https://api.mcelroy.com/rest/translation/upload/' + formData.language, resolve, toast)
                    })
                }) 
            }
        }
    ]

    // Page display
    return (
        <FormPage title="Export/Import" size="sm" fields={fields} buttons={buttons}>
        </FormPage>
    )
}

async function uploadFile(file, url, resolve, toast) {
    if(file != null) {
        const formData = new FormData()
        formData.append("file", file, file.name);
        formData.append("upload_file", true);

        const response = await fetch(url, {
            method: 'POST',
            credentials: 'include',
            body: formData
        })
        if(response.ok)
            toast.success("Translations updated")
        else
            toast.error("Error uploading file: " + response.statusText)
        resolve()
    }
}